export default __webpack_public_path__ + "static/omega-3-acids-be15c2d6c0315c74ba6ca00b83dff08e.jpg";